module.exports = __webpack_public_path__ + "static/media/naomi-woods-lesb.ec4b67df.jpg";